import type { Transaction } from '../api/types';
import { dayMonth, formatEuro } from '../lib/format';
import { useAddSheet } from './AddSheet';
import { useTransactionActions } from './TransactionRow';

/** Tabella dei movimenti per schermi larghi: data, categoria, nota, importo. */
export function TransactionTable({ transactions }: { transactions: Transaction[] }) {
  return (
    <table className="w-full overflow-hidden rounded-[var(--radius-card)] bg-surface text-sm">
      <thead>
        <tr className="border-b border-border text-left text-xs text-muted">
          <th className="px-4 py-2 font-normal">Data</th>
          <th className="px-4 py-2 font-normal">Categoria</th>
          <th className="px-4 py-2 font-normal">Nota</th>
          <th className="px-4 py-2 text-right font-normal">Importo</th>
        </tr>
      </thead>
      <tbody>
        {transactions.map((t) => (
          <TableRow key={t.id} transaction={t} />
        ))}
      </tbody>
    </table>
  );
}

function TableRow({ transaction }: { transaction: Transaction }) {
  const addSheet = useAddSheet();
  const { repeat, remove } = useTransactionActions(transaction);
  const isIncome = transaction.kind === 'INCOME';

  return (
    <tr className="group relative border-b border-border last:border-0 even:bg-surface-2/60 hover:bg-surface-2">
      <td className="tnum px-4 py-2 whitespace-nowrap text-muted">{dayMonth(transaction.date)}</td>
      <td className="px-4 py-2">
        <button
          type="button"
          onClick={() => addSheet.edit(transaction)}
          className="flex items-center gap-2 text-left"
        >
          <span
            className="inline-block h-2.5 w-2.5 shrink-0 rounded-full"
            style={{ background: transaction.category.color }}
            aria-hidden="true"
          />
          {transaction.category.name}
        </button>
      </td>
      <td className="max-w-0 truncate px-4 py-2 text-muted">{transaction.note ?? ''}</td>
      <td
        className={`tnum px-4 py-2 text-right font-semibold whitespace-nowrap ${isIncome ? 'text-success' : ''}`}
      >
        <span className="group-hover:invisible group-focus-within:invisible">
          {isIncome ? '+' : '−'}
          {formatEuro(transaction.amount)}
        </span>
        <span className="absolute inset-y-0 right-3 flex items-center gap-1 opacity-0 group-hover:opacity-100 group-focus-within:opacity-100">
          <button
            type="button"
            onClick={repeat}
            aria-label={`Ripeti ${transaction.category.name}`}
            className="rounded-md px-2 py-1 text-xs font-normal text-accent hover:bg-surface"
          >
            Ripeti
          </button>
          <button
            type="button"
            onClick={remove}
            aria-label={`Elimina ${transaction.category.name}`}
            className="rounded-md px-2 py-1 text-xs font-normal text-danger hover:bg-surface"
          >
            Elimina
          </button>
        </span>
      </td>
    </tr>
  );
}
